import { useAuth } from './useAuth';
import { ExternalChecklistDTO } from 'src/api/models/Opportunities/ExternalChecklistDTO';
import { useApiClient } from './useApiClient';
import { useState } from 'react';

type Document = {
	label: string;
	value: string;
	is_uploaded: boolean;
	uploadedFileName?: string;
	className?: string;
	createdAt?: string | null;
	isOpportunityReadOnly?: boolean | null;
};

export default function useOpportunityChecklist() {
	const { userRole } = useAuth();
	const { apiClient, handleApiResponse } = useApiClient();
	const [loadingChecklist, setLoadingChecklist] = useState(true);
	const [checklist, setChecklist] = useState<ExternalChecklistDTO | null>(null);
	const [documentationFolder, setDocumentationFolder] = useState<Document[]>(
		[]
	);

	const fetchChecklist = async (opportunityData?: any) => {
		if (!opportunityData?.Id) return;
		try {
			const externalChecklist: ExternalChecklistDTO = await handleApiResponse(
				apiClient.salesforceOpportunityController.getDocumentChecklist(
					opportunityData?.Id
				)
			);

			if (!externalChecklist) {
				setChecklist(null);
				return;
			}

			externalChecklist.items = (externalChecklist.items || []).map((item) => {
				const isField = item.type === 'field';
				item.isVariableType = isField;
				item.isFileType = !isField;
				item.isOk = isField
					? Boolean(item.value?.trim())
					: Boolean(item.key?.trim());
				return item;
			});

			setChecklist(externalChecklist);

			const xs = (externalChecklist.items || [])
				.filter((x) => x.isFileType)
				.map((x) => ({
					label: x.name,
					is_uploaded: x.isOk,
					createdAt: x.createdAt,
					uploadedFileName: x.isOk ? x.name : null,
				}));
			// @ts-ignore
			setDocumentationFolder(xs);
		} catch (error) {
			console.warn(error);
			setChecklist(null);
		} finally {
			setLoadingChecklist(false);
		}
	};

	return {
		checklist,
		loadingChecklist,
		documentationFolder,
		fetchChecklist,
	};
}
